// File drop hook for drag-and-drop file uploads
const FileDrop = {
  mounted() {
    this.dragCounter = 0;

    // Store bound handlers as instance properties
    this.boundPreventDefaults = this.preventDefaults.bind(this);
    this.boundHandleDragEnter = this.handleDragEnter.bind(this);
    this.boundHandleDragLeave = this.handleDragLeave.bind(this);
    this.boundHandleDrop = this.handleDrop.bind(this);

    // Create overlay element
    this.overlay = document.createElement('div');
    this.overlay.className = 'file-drop-overlay';
    this.overlay.innerHTML = `
      <div class="file-drop-content">
        <svg class="file-drop-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
        </svg>
        <div class="file-drop-text">Drop files to upload</div>
      </div>
    `;
    document.body.appendChild(this.overlay);

    // Use stored bound functions
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      window.addEventListener(eventName, this.boundPreventDefaults, false);
    });

    window.addEventListener('dragenter', this.boundHandleDragEnter, false);
    window.addEventListener('dragleave', this.boundHandleDragLeave, false);
    window.addEventListener('drop', this.boundHandleDrop, false);
  },

  destroyed() {
    // Use stored bound functions for cleanup
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      window.removeEventListener(eventName, this.boundPreventDefaults, false);
    });

    window.removeEventListener('dragenter', this.boundHandleDragEnter, false);
    window.removeEventListener('dragleave', this.boundHandleDragLeave, false);
    window.removeEventListener('drop', this.boundHandleDrop, false);

    // Remove overlay
    if (this.overlay && this.overlay.parentNode) {
      this.overlay.parentNode.removeChild(this.overlay);
    }
  },

  preventDefaults(e) {
    e.preventDefault();
    e.stopPropagation();
  },

  handleDragEnter(e) {
    this.dragCounter++;

    // Only show overlay if files are being dragged
    if (e.dataTransfer.types.includes('Files')) {
      this.overlay.classList.add('active');
    }
  },

  handleDragLeave(e) {
    this.dragCounter--;

    if (this.dragCounter === 0) {
      this.overlay.classList.remove('active');
    }
  },

  handleDrop(e) {
    this.dragCounter = 0;
    this.overlay.classList.remove('active');

    const dt = e.dataTransfer;
    const files = dt.files;

    if (files && files.length > 0) {
      // Get target upload input ID from data attribute
      const targetUploadId = this.el.dataset.targetUpload;
      // Try to find by ID first, then fall back to LiveView's upload selector
      const uploadInput = (targetUploadId && document.getElementById(targetUploadId)) ||
        document.querySelector('input[type="file"][data-phx-upload-ref]');

      if (!uploadInput) {
        return;
      }

      // Create a new FileList-like object
      const dataTransfer = new DataTransfer();

      // Allowed file types (matching the upload config)
      const allowedTypes = [
        'image/jpeg', 'image/png', 'image/gif', 'image/webp',
        'application/pdf',
        'text/plain', 'text/markdown', 'text/csv', 'text/x-markdown',
        'application/json'
      ];

      // Filter for allowed file types
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (allowedTypes.includes(file.type) || file.type.startsWith('image/') || file.type.startsWith('text/')) {
          dataTransfer.items.add(file);
        }
      }

      if (dataTransfer.files.length > 0) {
        // Set the files on the LiveView upload input
        uploadInput.files = dataTransfer.files;

        // Dispatch the input event that LiveView's upload system listens for
        uploadInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  }
};

export default FileDrop;
